import React from 'react'

import { Field } from 'formik'

import { Col, Form } from '_zari/core'

const TipoCambioFormGroup = ({ iError, iTouched, fIsSubmitting }) => {
  return (
    <Form.Group>
      <Form.Label text='TIPO CAMBIO' htmlFor='input-modalavanz-tipoCambio' md={12} />
      <Col md={12}>
        <Field name='tipoCambio'>
          {({ field }) => <Form.InputNumber {...field} id='input-modalavanz-tipoCambio' isInvalid={iTouched && iError} disabled={fIsSubmitting} />}
        </Field>
        {iTouched && iError ? <Form.Feedback type='invalid'>{iError}</Form.Feedback> : null}
      </Col>
    </Form.Group>
  )
}

export default React.memo(TipoCambioFormGroup)
